// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"e8139b32","29":"1d6a1433","108":"50f71ebc","406":"85bc0dc8","661":"98f8f6b0"}[chunkId] + ".chunk.css";
};